<template>
  <div class="content-main page-parcel">

    <div class="ptitle">快递信息</div>

    <van-form @submit="onSubmit">
      <van-field
      v-model="parcel.sender_name"
      name="寄件人姓名"
      label="寄件人姓名:"
      placeholder="请填写寄件人姓名"/>
      <van-field
      v-model="parcel.sender_phone"
      name="寄件人电话"
      label="寄件人电话:"
      placeholder="请填写寄件人电话"/>
      <van-field
      v-model="parcel.receiver_name"
      name="收件人姓名"
      label="收件人姓名:"
      placeholder="请填写收件人姓名"/>
      <van-field
      v-model="parcel.receiver_phone"
      name="收件人电话"
      label="收件人电话:"
      placeholder="请填写收件人电话"/>
      <van-field
        readonly
        clickable
        name="area"
        :value="parcel.district"
        label="收件地址:"
        placeholder="请选择省份/城市/区县/街道乡镇"
        @click="showPickerDistricts = true"
      />
      <!-- <van-popup v-model="showPickerDistricts" position="bottom">
        <van-area
          :area-list="columnsDistricts"
          :title="districtsPickerTitle"
          @cancel="onCancelDistricts"
          @confirm="onConfirmDistricts"
        />
      </van-popup> -->
      <van-popup class="popup-districts" v-model="showPickerDistricts" round position="bottom">
        <van-picker
        class="picker-districts"
        show-toolbar
        :columns="columnsDistricts"
        value-key="name"
        :title="districtsPickerTitle"
        @cancel="onCancelDistricts"
        @confirm="onConfirmDistricts"
        />
      </van-popup>
      <van-field
        v-model="parcel.address"
        type="textarea"
        rows="1" autosize
        label="      "
        placeholder="请填写详细地址，小区/楼栋/门牌号等" />
      <van-field
      v-model="parcel.remark"
      name="备注"
      label="备注:"
      placeholder="此项可不填"/>


      <div style="margin:25px;">
        <van-button round block color="#b17e94" native-type="submit">确认并支付 29.9元</van-button>
      </div>
    </van-form>

    <van-popup v-model="loading" class="pop-loading" :close-on-click-overlay="false">
      <div class="loading">
        <span>正在拼命提交中，请稍等片刻～</span>
        <van-loading type="spinner" />
      </div>
    </van-popup>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Form, Field, Button, Popup, Picker, Loading, Dialog } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Dialog.name]: Dialog
  },
  data(){
    return {
      parcel: {
        sender_name: "",
        sender_phone: "",
        receiver_name: "",
        receiver_phone: "",
        district: "",
        address: "",
        province: "",
        type: "",
        remark: ""
      },
      showPickerDistricts: false,
      columnsDistricts: [],
      districtsPickerTitle: '选择省份',
      districtsPickerType: 1,
      provinceTmp: '',
      provinces: [],
      loading: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    onSubmit(){
      if(this.loading){
        return
      }if(!this.parcel.sender_name){
        Toast('请填写寄件人姓名')
      }else if(!this.parcel.sender_phone){
        Toast('请填写寄件人电话')
      }else if(!this.parcel.receiver_name){
        Toast('请填写收件人姓名')
      }else if(!this.parcel.receiver_phone){
        Toast('请填写收件人电话')
      }else if(!this.parcel.district){
        Toast('请选择省份/城市/区县/街道乡镇')
      }else if(!this.parcel.address){
        Toast('请填写详细地址，小区/楼栋/门牌号等')
      }else if(this.parcel.sender_name == this.parcel.receiver_name){
        let _this = this
        Dialog.confirm({
          title: '确认提醒',
          message: `检测到您填写的快递收件人与寄件人姓名相同，均为：${this.parcel.sender_name}，请您确认信息是否正确`,
          confirmButtonText: '确认',
          cancelButtonText: '修改'
        })
        .then(() => {
          // on confirm
          _this.loading = true
          _this.handlePay()
        })
        .catch(() => {
          // on cancel
        });
      }else{
        this.loading = true
        this.handlePay()
      }
    },
    handlePay(){
      let openid = this.$store.state.userinfo.openid
      let mail = this.$store.state.mail_draft
      let parcel = this.parcel
      let remark = this.parcel.remark.trim().length > 0 ? this.parcel.remark : "无"
      let referal = this.$store.state.referal
      this.$api.post('/momentbox/pay_for_postcard', {
        openid: openid, mail_sender: mail.sender, mail_receiver: mail.receiver, mail_content: mail.content, mail_square: mail.square, mail_schedule: mail.schedule,
        sender_name: parcel.sender_name, sender_phone: parcel.sender_phone, receiver_name: parcel.receiver_name, receiver_phone: parcel.receiver_phone,
        district: parcel.district, address: parcel.address, province: parcel.province, remark: remark, referal: referal
      }, res => {
        this.loading = false
        if(res.code == 200){
          // alert("pay res: " + JSON.stringify(res))
          let _this = this
          wx.chooseWXPay({
            timestamp: res.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
            package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: res.paySign, // 支付签名
            success: function (payRes) {
              // 支付成功后的回调函数
              // alert("pay success: " + JSON.stringify(payRes))
              // _this.handleRouter('/mail_submitted_success/postcard')
              _this.$router.replace("/mail_submitted_success/postcard")
            },
            fail: function (payErr){
              // alert("pay fail: " + JSON.stringify(payErr))
              Toast('出错了，请稍后再试～')
            }
          })
        }else{
          Toast(res.msg)
        }
      })
    },
    onConfirmDistricts(obj){
      if(this.districtsPickerType == 1){
        this.$api.get('/district/get_cities_by_province', {provinceid: obj.code}, res => {
          if(res.code == 200){
            this.columnsDistricts = res.cities
            this.districtsPickerTitle = obj.name
            this.districtsPickerType = 2
            this.provinceTmp = obj.code
          }
        })
      }else if(this.districtsPickerType == 2){
        this.$api.get('/district/get_counties_by_city', {cityid: obj.code}, res => {
          if(res.code == 200){
            this.columnsDistricts = res.counties
            this.districtsPickerTitle += obj.name
            this.districtsPickerType = 3
          }
        })
      }else if(this.districtsPickerType == 3){
        this.$api.get('/district/get_towns_by_county', {countyid: obj.code}, res => {
          if(res.code == 200 && (res.towns.length > 0)){
            this.columnsDistricts = res.towns
            this.districtsPickerTitle += obj.name
            this.districtsPickerType = 4
          }else{
            this.parcel.district = this.districtsPickerTitle + obj.name
            this.parcel.province = this.provinceTmp
            this.showPickerDistricts = false
            this.districtsPickerType = 1
            this.districtsPickerTitle = "选择省份"
            this.columnsDistricts = this.provinces
          }
        })
      }else if(this.districtsPickerType == 4){
        this.parcel.district = this.districtsPickerTitle + obj.name
        this.parcel.province = this.provinceTmp
        this.showPickerDistricts = false
        this.districtsPickerType = 1
        this.districtsPickerTitle = "选择省份"
        this.columnsDistricts = this.provinces
      }
    },
    onCancelDistricts(){
      this.showPickerDistricts = false
      this.districtsPickerType = 1
      this.districtsPickerTitle = "选择省份"
      this.columnsDistricts = this.provinces
    },
    getProvinces(){
      this.$api.get('/district/get_provinces', {}, res => {
        if(res.code == 200){
          this.columnsDistricts = res.provinces
          this.provinces = res.provinces
        }
      })
    },
    wxConfigInit(){
      this.$api.get('/momentbox/get_wx_js_config', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });
        }
      })
    }
  },
  mounted(){
    this.getProvinces()
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{min-height:100vh;text-align:left;background-color: #f8f8f8;}
.ptitle{text-align:center;font-size:35px;color:#333;padding-top:30px;padding-bottom:30px;font-weight:bold;}

.pop-loading{width:70%;padding:20px;margin:0 auto;}
.pop-loading{background:rgba(255,255,255,0);color:#fff;}
.content-main .loading .van-loading{margin:0 auto;margin-bottom:15px;margin-top:30px;}
.content-main .loading{ font-size:20px;padding:20;text-align:center;}
</style>
